import { ComboBox } from "@progress/kendo-react-dropdowns";

function TargetCell({ dataItem, hidden, pages, onChange }) {

    const handleTarget = (e) => {
        onChange(e, dataItem);
    };

    if (!dataItem.hyperlink) {
        if (
            ['Phone', 'Boolean', 'Html', 'Tags', 'TreePath', 'Image', 'Email', 'URL'].includes(dataItem.attributeType)
        ) {
            return (
                <td>
                    <span className={hidden ? 'text-muted' : ''}>N/A</span>
                </td>
            );
        } else {
            return <td></td>;
        }
    }

    if (dataItem.selected) {
        const targetPages = pages.filter(
            (page) => page.entityId === dataItem.entityId
        );
        const uniqueTargetPages = targetPages.filter(
            (page, index, self) =>
                index === self.findIndex((p) => p._id === page._id)
        );

        const value =
            typeof dataItem.target === 'object'
                ? dataItem.target
                : uniqueTargetPages.find((page) => page._id === dataItem.targetPageId);

        return (
            <td>
                <ComboBox
                    value={value}
                    disabled={dataItem.hidden}
                    textField="pageName"
                    data={uniqueTargetPages}
                    onChange={handleTarget}
                    className="form-control-custom"
                />
            </td>
        );
    } else {
        const page = pages.find((page) => page._id === dataItem.targetPageId);

        return (
            <td>
                {page === undefined ? (
                    <span className="red f-12">Select Page</span>
                ) : (
                    <span className={hidden ? 'text-muted' : ''}>{page.pageName}</span>
                )}
            </td>
        );
    }
}

export default TargetCell;